import React, { Fragment, useEffect } from 'react';
import NavBar from '../../components/nav/NavBar.js';
import Banner from '../../components/banner/Banner.js';
import PageImage from '../../components/page-image/PageImage.js';
import ServicesContent from '../../components/services-content/ServicesContent.js';
import ServicesList from '../../components/services-list/ServicesList.js';
import InfoBanner from '../../components/info-banner/InfoBanner.js';
import Brands from '../../components/brands/Brands.js';
import Reviews from '../../components/reviews/Reviews.js';
import SplashImage from '../../components/splash-image/SplashImage.js';
import Footer from '../../components/footer/Footer.js';
import './Services.css';

function Services() {

    useEffect(() => {
        document.title = "R.E.M - Services"
      }, []);

    return (
        <Fragment>
            <div className="fixed-header">
                <div className="nav-bar-container">
                    <NavBar />
                </div>
                <div className="banner-container">
                    <Banner />
                </div>
            </div>
            <div className="fixed-header-content">
                <div className="page-image-container">
                    <PageImage imageText={"Services"}/>
                </div>
                <div className="services-content-list-banner-container">
                    <div className="content-container">
                        <ServicesContent />
                    </div>
                    <div className="services-banner-container">
                        <ServicesList />
                    </div>
                </div>
                <div className="info-banner-container">
                        <InfoBanner />
                </div>
                <div className="brands-reviews-container">
                    <div className="brands-container">
                            <Brands />
                    </div>
                    <div className="reviews-container">
                            <Reviews />
                    </div>
                </div>
                <div className="splash-image-container">
                        <SplashImage />
                </div>
                <div className="footer-container">
                        <Footer />
                </div>
                </div>
        </Fragment>
    );

}

export default Services;